module.exports = __webpack_public_path__ + "static/media/bulk3.851eb54c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Tutorial/screenshots/Creating/bulk3.jpg
// module id = 1629
// module chunks = 0